const postStatusOptions = (isPlanned: boolean) => [
  { value: "draft", label: "Szkic" },
  { value: "withdrawn", label: "Wycofana" },
  { value: "published", label: isPlanned ? "Zaplanowana" : "Opublikowana" },
];

export default postStatusOptions;
